<template>
    <div id="administrator-claims">
        <b-overlay :show="showLoading" spinner-variant="primary">
            <b-card>
                <ag-grid :withFilters="true" :filterComponent="AgGridDateFilterLastWeek" :agGrid="agGrid"
                    pageTitle="Liste des réclamations" @refresh="loadData" @filterClicked="filterClicked" />
            </b-card>
        </b-overlay>
    </div>
</template>

<script>

import AgGrid from "@/views/components/ag-grid/AgGrid.vue"
import BadgeCellRenderer from "../components/ag-grid/BadgeCellRenderer.vue";
import AgGridDateFilterLastWeek from "@/views/components/ag-grid/AgGridDateFilterLastWeek.vue"

export default {
    components: {
        AgGrid,
    },
    data() {
        return {
            showLoading: false,
            AgGridDateFilterLastWeek: AgGridDateFilterLastWeek,
            startDate: (() => {
                const date = new Date();
                date.setDate(date.getDate() - 7);
                return date.toISOString().split('T')[0];
            })(),
            endDate: new Date().toISOString().split('T')[0],
            agGrid: {
                columnDefs: [
                    {
                        headerName: "Date",
                        field: "Date",
                    },
                    {
                        headerName: "Client",
                        field: "Customer_Name",
                    },
                    {
                        headerName: "Type",
                        field: "Complaint_Type",
                    },
                    {
                        headerName: "Motif",
                        field: "Reason_Description",
                    },
                    {
                        headerName: "Réclamation",
                        field: "Wording",
                    },
                    {
                        headerName: "Traité par",
                        field: "Treated_Name",
                    },
                    {
                        headerName: "Statut",
                        field: "Statut",
                        cellClass: 'centered-customeCellRender',
                        cellRendererFramework: 'badgeCellRenderer',
                        cellRendererParams: { componentName: "Claims" },
                        width: 90
                    },
                ],
                rows: []
            },
        }
    },
    created() {
        this.$options.components.badgeCellRenderer = BadgeCellRenderer;
        this.loadData();
    },
    methods: {
        filterClicked(obj) {
            this.startDate = obj.sDate;
            this.endDate = obj.eDate;
            this.loadData();
        },
        async loadData() {
            this.showLoading = true;
            let response = await this.$http.post("claim/findWhere", this.generateDateFilters()).catch(() => {
                this.showLoading = false;
            });
            if (!response || !response.data) {
                this.agGrid.rows = [];
                this.showLoading = false;
                return;
            }
            this.agGrid.rows = [...response.data].reverse();
            this.showLoading = false;
        },
        generateDateFilters() {
            const filters = [
                { field: "Date", value: "", operator: "gt" },
                { field: "Date", value: "", operator: "lt" },
            ];

            const startDateObj = new Date(this.startDate);
            startDateObj.setDate(startDateObj.getDate() - 1);
            const endDateObj = new Date(this.endDate);
            endDateObj.setDate(endDateObj.getDate() + 1);

            filters[0].value = startDateObj.toISOString().split('T')[0];
            filters[1].value = endDateObj.toISOString().split('T')[0];

            return filters;
        }
    }
}
</script>

<style lang="scss"></style>
